export enum ToastEmitterOptionsPosition {
    top = "top", bottom = "bottom", topRight = "top-right", bottomRight = "bottom-right", topLeft = "top-left", bottomLeft = "bottom-left"
}